// extracted by mini-css-extract-plugin
export default {"root":"fAG5rg","content":"g8VYqO","actions":"UW_ubC","hidden":"gEoLBQ","title":"lp69Ov","mobile":"EiAqKR","info":"JIqhgF"};